/**
 * 字符串去空格工具类(包括首尾以及中间的空格)
 */
export class TrimUtil {
  private static removeAllSpaces(value: string): string {
    return value.replace(/\s+/g, '');
  }

  /**
   * 去除字符串中所有空白字符
   * @param value 待处理的字符串
   * @returns 去除空白后的字符串
   */
  static trim(value: any): string {
    if (value === null || value === undefined) {
      return '';
    }
    if (typeof value === 'string') {
      return TrimUtil.removeAllSpaces(value);
    }
    return TrimUtil.removeAllSpaces(String(value));
  }

  /**
   * 去除对象中所有字符串属性的所有空白字符
   * @param obj 待处理的对象
   * @returns 处理后的对象
   */
  static trimObject(obj: any): any {
    if (!obj || typeof obj !== 'object') {
      return obj;
    }

    const trimmedObj = { ...obj };
    Object.keys(trimmedObj).forEach(key => {
      if (typeof trimmedObj[key] === 'string') {
        trimmedObj[key] = TrimUtil.removeAllSpaces(trimmedObj[key]);
      }
    });
    return trimmedObj;
  }

  /**
   * 去除数组中所有字符串的所有空白字符
   * @param arr 待处理的字符串数组
   * @returns 处理后的数组
   */
  static trimStringArray(arr: string[]): string[] {
    if (!arr || !Array.isArray(arr)) {
      return arr;
    }
    return arr.map(item => typeof item === 'string' ? TrimUtil.removeAllSpaces(item) : item);
  }
}
